import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Upload, BookOpen, CheckCircle, Package, ShoppingCart, BarChart3, Clock, Settings, LogOut } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/', label: 'Inicio', icon: LayoutDashboard },
  { path: '/upload', label: 'Cargar archivos', icon: Upload },
  { path: '/catalog', label: 'Catálogo', icon: BookOpen },
  { path: '/homologation', label: 'Validar productos', icon: CheckCircle },
  { path: '/inventory', label: 'Inventario', icon: Package },
  { path: '/orders', label: 'Pedido sugerido', icon: ShoppingCart },
  { path: '/reports', label: 'Reportes', icon: BarChart3 },
  { path: '/history', label: 'Historial', icon: Clock },
  { path: '/settings', label: 'Configuración', icon: Settings },
];

const TITLES = {
  '/': { title: 'Panel Ejecutivo', subtitle: 'Resumen de inventarios y operaciones' },
  '/upload': { title: 'Cargar Archivos', subtitle: 'Importar ventas, inventario y documentos' },
  '/catalog': { title: 'Catálogo Maestro', subtitle: 'Gestión de productos y marcas' },
  '/homologation': { title: 'Validar Productos', subtitle: 'Homologación de nomenclaturas' },
  '/inventory': { title: 'Inventario', subtitle: 'Estado actual del inventario' },
  '/orders': { title: 'Pedido Sugerido', subtitle: 'Órdenes de compra inteligentes' },
  '/reports': { title: 'Reportes', subtitle: 'Análisis de ventas y tendencias' },
  '/history': { title: 'Historial', subtitle: 'Bitácora de operaciones y auditoría' },
  '/settings': { title: 'Configuración', subtitle: 'Usuarios, roles y reglas de negocio' },
};

export default function Layout({ children, user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { title, subtitle } = TITLES[location.pathname] || TITLES['/'];

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className="sidebar" data-testid="sidebar">
        <div className="sidebar-logo">
          <h1>LubriStock</h1>
          <p>Inventarios Inteligentes</p>
        </div>
        <nav className="sidebar-nav">
          {NAV_ITEMS.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <div
                key={item.path}
                className={`sidebar-nav-item ${isActive ? 'active' : ''}`}
                onClick={() => navigate(item.path)}
                data-testid={`nav-${item.path.replace('/', '') || 'home'}`}
              >
                <Icon />
                <span>{item.label}</span>
              </div>
            );
          })}
        </nav>
        <div className="sidebar-user">
          <div className="sidebar-user-avatar">
            {(user?.name || 'U').charAt(0).toUpperCase()}
          </div>
          <div className="sidebar-user-info">
            <div className="name">{user?.name || 'Usuario'}</div>
            <div className="role">{user?.role || 'analista'}</div>
          </div>
          <button
            onClick={onLogout}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'hsl(210 20% 55%)', padding: '4px' }}
            data-testid="logout-button"
          >
            <LogOut size={16} />
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <div className="topbar">
          <span className="topbar-title">{title}</span>
          <span className="topbar-subtitle">{subtitle}</span>
        </div>
        <div className="page-content">
          {children}
        </div>
      </main>
    </div>
  );
}
